function t(){return!1}export{t as default};
//# sourceMappingURL=stubFalse.js.map
